import { Text } from '@mantine/core';

interface HighlightProps {
  text: string;
  searchTerm: string;
  className?: string;
  highlightClassName?: string;
}

export const Highlight = ({ text, searchTerm, className, highlightClassName = 'bg-yellow-200' }: HighlightProps) => {
  if (!searchTerm || !searchTerm.trim()) {
    return <span className={className}>{text}</span>;
  }

  const parts = text.split(new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi'));

  return (
    <span className={className}>
      {parts.map((part, index) =>
        part.toLowerCase() === searchTerm.toLowerCase() ? (
          <mark key={index} className={highlightClassName} style={{ backgroundColor: '#fef08a', padding: '0 2px' }}>
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </span>
  );
};

export default Highlight;
